import React, {ChangeEvent} from 'react';
import {Platform} from 'react-native';
import CheckBox, {CheckBoxProps as RNCheckBoxProps} from '@react-native-community/checkbox';

import theme from '../../../style/theme';

type CheckBoxProps = Omit<RNCheckBoxProps, 'value'> & {
  checked?: boolean;
  onChange: (value: boolean) => void;
};

// TODO: This is a halfbacked component to unblock this codebase's Web export
export default function Checkbox({checked, onChange, ...rest}: CheckBoxProps) {
  const handleWebChange = (event: ChangeEvent<HTMLInputElement>) => onChange(!!event.target.value);

  const mobileProps = Platform.OS === 'android' && {
    // for some reason the unchecked checkbox is completely invisible on Android
    tintColors: {
      true: theme.colour.checkbox.primary,
      false: theme.colour.checkbox.primary,
    },
  };

  return Platform.OS === 'web' ? (
    <input type="checkbox" onChange={handleWebChange} checked={checked} data-testid="checkbox" />
  ) : (
    <CheckBox
      testID="checkbox"
      value={checked}
      onValueChange={onChange}
      {...mobileProps}
      {...rest}
    />
  );
}
